import React from "react";
import { ISupportTilesProps } from "./SupportTilesProps";
import { MenuBlock, TileLink } from "./SupportTilesHelpers";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SupportTiles: React.FC<ISupportTilesProps> = (props) => {
  const sections = props?.node?.relationships?.field_tiles || null;
  return (
    <Container className="pt-5 pb-5" fluid="sm">
      <Row noGutters>
        {sections.map((section, i) => {
          return (
            <MenuBlock lg={3} key={i}>
              <div className="border">
                <FontAwesomeIcon
                  icon={section.field_icon_name}
                  className="icon"
                  size="lg"
                />
                <h3>{section.field_title}</h3>
                {section.field_links.map((link, y) => {
                  return (
                    <div className="link" key={y}>
                      <TileLink link={link} onClick={props.onTileClick} />
                    </div>
                  );
                })}
              </div>
            </MenuBlock>
          );
        })}
      </Row>
    </Container>
  );
};

export default SupportTiles;
